module.exports = __webpack_public_path__ + "img/28_79.865b1ad9.png";